// extracted by mini-css-extract-plugin
export default {"canvas":"ParticleBackground_canvas__FQ2CA"};